(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('LotDialogController', LotDialogController);

    LotDialogController.$inject = ['$timeout', '$scope', '$q', 'entity', 'Lot', 'Contract', 'Shipment',
        'Comment', 'Principal', 'ToastrService', 'ContractCustomService', 'ShipmentCustomService', 'CommentCustomService',
        'AttachmentCustomService', '$uibModal', '$rootScope', 'LotCustomService', 'MiscService', '$stateParams', '$state'];

    function LotDialogController ($timeout, $scope, $q, entity, Lot, Contract, Shipment, Comment,
                                  Principal, ToastrService, ContractCustomService, ShipmentCustomService, CommentCustomService,
                                  AttachmentCustomService, $uibModal, $rootScope, LotCustomService, MiscService, $stateParams, $state) {
        var vm = this;

        vm.lot = entity;

        if ($stateParams.activeTab && $stateParams.activeTab >= 0) {
            $scope.activeTab = $stateParams.activeTab;
        }

        //initialize values
        vm.comments = [];
        vm.attachments = [];
        vm.showPContractDetails = false;
        // fetchGrowths();
        vm.principal = {};
        fetchPrincipal();
        vm.comment = "";
        vm.datePickerOpenStatus = {};
        fetchPurchaseContractList();
        initLot();

        vm.activateLotStatus = activateLotStatus;
        vm.activateWtType = activateWtType;
        vm.calculateAvgNet = calculateAvgNet;
        vm.nl2br = MiscService.nl2br;

        // if (vm.lot.id > 0) {
        //     LotCustomService.returnLotAuditById(vm.lot.id).then(function (data) {
        //         vm.audits = data.data;
        //     }, function (error) {
        //         console.log(error.status, error.statusText);
        //     });
        // }

        function fetchPrincipal() {
            Principal.identity().then( function( principal ) {
                vm.principal = principal;
            }, function() {
                ToastrService.error( "Failed to get current user", "Error!" );
            });
        }

        function initLot() {
            if (vm.lot.id === null) {
                vm.lot.lotStatus = "AVAILABLE";
                vm.siList = [];
                //actual weights holder
                vm.actualWeightNet = 0;
                vm.actualWeightGross = 0;
                vm.actualWeightTare = 0;
                vm.actualWeightAvg = 0;
                vm.actualWeightGrossAvg = 0;
                vm.actualWeightTareAvg = 0;
                //landed weights holder
                vm.landedWeightNet = 0;
                vm.landedWeightGross = 0;
                vm.landedWeightTare = 0;
                vm.landedWeightAvg = 0;
                vm.landedWeightGrossAvg = 0;
                vm.landedWeightTareAvg = 0;
                //sale & landed values
                vm.saleValue = 0;
                vm.landedValue = 0;
                //sale vs landed value difference
                vm.difference = 0;
            } else {
                getContractQuality();
                applyPurchSiDetails();
                fetchShipments();
                // var contractPromise = [];
                // contractPromise.push(
                //     ContractCustomService.returnPurchaseContractByLot(vm.lot.id).then(function (data) {
                //         vm.lot.purchase = data.data;
                //         vm.showPContractDetails = true;
                //         ToastrService.success("Fetched Purchase Contract", "Success!");
                //     }, function (error) {
                //         if (error.status !== 404) {
                //             ToastrService.error("Cannot fetch Purchase Contract: " + error.statusText, "Error");
                //         }
                //         vm.shoePContractDetails = false;
                //         console.log(error.statusText);
                //     })
                // );
                // contractPromise.push(
                //     ShipmentCustomService.returnPurchShipmentByLot(vm.lot.id).then(function (data) {
                //         vm.lot.purchSi = data.data;
                //     }, function (error) {
                //         if (error.status !== 404) {
                //             ToastrService.error("Cannot fetch Shipment: " + error.statusText, "Error");
                //         }
                //         console.log(error.statusText);
                //     })
                // );
                // $q.all(contractPromise).then(function () {
                //     applyPurchSiDetails();
                //     fetchShipments();
                // });

                if (vm.lot.purchWtType === undefined || vm.lot.purchWtType === null) {
                    vm.lot.purchWtType = 'KG';
                }

                switch (vm.lot.purchWtType) {
                case 'KG':
                    //actual weights holder
                    vm.actualWeightNet = vm.lot.purchNetKgs;
                    vm.actualWeightGross = vm.lot.purchGrossKgs;
                    vm.actualWeightTare = vm.lot.purchTareKgs;
                    //landed weights holder
                    vm.landedWeightNet = vm.lot.purchLandedNetKgs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossKgs;
                    vm.landedWeightTare = vm.lot.purchLandedTareKgs;
                    break;
                case 'LB':
                    //actual weights holder
                    vm.actualWeightNet = vm.lot.purchNetLbs;
                    vm.actualWeightGross = vm.lot.purchGrossLbs;
                    vm.actualWeightTare = vm.lot.purchTareLbs;
                    //landed weights holder
                    vm.landedWeightNet = vm.lot.purchLandedNetLbs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossLbs;
                    vm.landedWeightTare = vm.lot.purchLandedTareLbs;
                    break;
                case 'MT':
                    //actual weights holder
                    vm.actualWeightNet = vm.lot.purchNetMTs;
                    vm.actualWeightGross = vm.lot.purchGrossMTs;
                    vm.actualWeightTare = vm.lot.purchTareMTs;
                    //landed weights holder
                    vm.landedWeightNet = vm.lot.purchLandedNetMTs;
                    vm.landedWeightGross = vm.lot.purchLandedGrossMTs;
                    vm.landedWeightTare = vm.lot.purchLandedTareMTs;
                    break;
                }
                vm.actualWeightAvg = vm.lot.actualWtAvg;
                vm.landedWeightAvg = vm.lot.landedWtAvg;
                vm.actualWeightGrossAvg = vm.lot.actualWtGrossAvg;
                vm.landedWeightGrossAvg = vm.lot.landedWtGrossAvg;
                vm.actualWeightTareAvg = vm.lot.actualWtTareAvg;
                vm.landedWeightTareAvg = vm.lot.landedWtTareAvg;
                //get comments
                resolveComments();
                //get attachments
                resolveAttachments();
                calculateAvgNet();
            }
        }

        //lists
        vm.lotStatuses = ['AVAILABLE','ALLOCATED','SHIPPED'];
        vm.wtTypes = ['KG', 'LB', 'MT'];

        //fancy stuff
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        //fancy way to select all text inside input box on click
        vm.onTextClick = function( $event ) {
            $event.target.select();
        };

        function clear () {
            // $uibModalInstance.dismiss('cancel');
        }

        //save function
        function save () {
            //disable save button to avoid double click
            vm.isSaving = true;
            if (vm.lot.lotStatus === "AVAILABLE" && vm.lot.allocSi !== null && vm.lot.allocSi !== undefined) {
               vm.lot.lotStatus = "ALLOCATED";
            }
            if (vm.lot.purchWtType === "" || vm.lot.purchWtType === null) {
                ToastrService.error("Lot Details: No Qty Unit Type chosen", "Warning!");
                vm.isSaving = false;
            } else if (vm.lot.qtyBales === undefined || vm.lot.qtyBales === null || vm.lot.qtyBales < 1) {
                ToastrService.error("Lot Details: Enter Qty Bales", "Warning!");
                vm.isSaving = false;
            } else {
                if (vm.lot.id !== null) {
                    //if lot has an id -- do an update
                    Lot.update(vm.lot, onSaveSuccess, onSaveError);
                } else {
                    //if lot does not have an id -- do a save
                    Lot.save(vm.lot, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            var newLot = vm.lot.id === null;
            vm.lot.id = result.id;
            if (newLot) {
                var promlist = [];
                if(vm.lot.allocSi) {
                    if(vm.lot.allocSi.status === "DRAFT") {
                        // promlist.push(ShipmentCustomService.updateShipmentStatusById(vm.lot.allocSi.id, "ALLOCATED"));
                    }
                }
                if (vm.comments.length > 0) {
                    var comments = [];
                    for (var x = 0; x < vm.comments.length; x++) {
                        if (vm.comments[x].id === null) {
                            comments.push(vm.comments[x]);
                        }
                    }
                    if (comments.length > 0) {
                        promlist.push(CommentCustomService.assignParentToComment(vm.comments, vm.lot.id, "lot"));
                    }
                }
                if ($scope.files.length > 0) {
                    angular.forEach($scope.files, function (file) {
                        promlist.push(AttachmentCustomService.uploadAttachment(file, "lot", vm.lot.id, file.name));
                    });
                }
                if (promlist.length > 0) {
                    $q.all(promlist).then(function () {
                        finalizeSave();
                    }).then(function () {
                        finalizeSave();
                    });
                } else {
                    finalizeSave();
                }
            } else {
                finalizeSave();
            }
        }

        function finalizeSave() {
            vm.isSaving = false;
            resolveDates();
            ToastrService.success( "Lot Saved Successfully!", "Success!");
            var data = {
                heading: 'Detail ' + vm.lot.lotRef,
                route: 'lot.lot-detail',
                id: vm.lot.id,
                param: {id: ''}
            };
            $rootScope.$emit('handleEmit', data);
        }

        function onSaveError () {
            ToastrService.error( "Something went wrong while saving the Lot", "Error" );
            vm.isSaving = false;
        }

        function resolveDates() {
            if(vm.lot.loadingDate !== null) {
                vm.lot.loadingDate = MiscService.dateFix(vm.lot.loadingDate);
            }
        }

        //initializing myUuid
        vm.lot.myUuid = generateUUID();

        //generate uuid
        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        //=========================================
        //PURCHASE & ALLOCATION TAB
        //=========================================
        //apply values on purchase contract to lots as well
        vm.applyPurchaseContractStuff = applyPurchaseContractStuff;
        vm.applyPurchSiDetails = applyPurchSiDetails;
        vm.clearShipment = clearShipment;
        vm.fetchPurchaseContractList = fetchPurchaseContractList;
        vm.fetchShipments = fetchShipments;

        function applyPurchaseContractStuff() {
            if( vm.lot.purchase !== null && vm.lot.purchase !== undefined ) {
                // vm.showPContractDetails = true;
                getContractQuality();
                fetchShipments();
                applyPurchSiDetails();
                vm.lot.cropYear = vm.lot.purchase.cropYear;
                vm.lot.seller = vm.lot.purchase.seller.name;
                vm.lot.growth = vm.lot.purchase.growth.location;
            } else {
                vm.showPContractDetails = false;
                vm.lot.cropYear = null;
                vm.lot.seller = null;
                vm.lot.growth = null;
            }
        }

        function applyPurchSiDetails() {
            if( vm.lot.purchSi !== null && vm.lot.purchSi !== undefined ) {
                // ContractCustomService.returnSaleContractByShipment( vm.lot.purchSi.id ).then( function( data ) {
                ContractCustomService.returnMinifiedSaleContractByShipment( vm.lot.purchSi.id ).then( function( data ) {
                    vm.lot.allocSale = data.data;
                    vm.lot.allocSi = vm.lot.purchSi;
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Failed to get Sale Contract: " + error.statusText, "Error" );
                    } else {
                        vm.lot.allocSale = null;
                        vm.lot.allocSi = null;
                    }
                    console.log( error.statusText );
                });
            } else {
                vm.lot.lotStatus = "AVAILABLE";
                vm.lot.allocSale = null;
                vm.lot.allocSi = null;
            }
        }

        function getContractQuality() {
            if(vm.lot.purchase !== null && vm.lot.purchase !== undefined) {
                ContractCustomService.getContractQualityById(vm.lot.purchase.id).then(function(data) {
                    vm.lot.purchase.quality = data.data.quality;
                    vm.lot.purchase.strength = data.data.strength;
                    vm.lot.purchase.strengthRange = data.data.strengthRange;
                    vm.lot.purchase.range = data.data.range;
                    vm.lot.purchase.mic = data.data.mic;
                    vm.lot.purchase.gradeDescription = data.data.gradeDescription;
                    vm.lot.purchase.gradeGreenCard = data.data.gradeGreenCard;
                    vm.lot.purchase.stapleDescription = data.data.stapleDescription;
                    vm.lot.purchase.stapleGreenCard = data.data.stapleGreenCard;
                    vm.lot.purchase.leafGreenCard = data.data.leafGreenCard;
                    vm.lot.purchase.unf = data.data.unf;
                    vm.lot.purchase.length = data.data.length;
                    vm.lot.purchase.gradeDescriptionDisplay = data.data.gradeDescriptionDisplay;
                    vm.lot.purchase.gradeGreenCardDisplay = data.data.gradeGreenCardDisplay;
                    vm.lot.purchase.stapleDescriptionDisplay = data.data.stapleDescriptionDisplay;
                    vm.lot.purchase.stapleGreenCardDisplay = data.data.stapleGreenCardDisplay;
                    vm.lot.purchase.leafGreenCardDisplay = data.data.leafGreenCardDisplay;
                    vm.lot.purchase.micDisplay = data.data.micDisplay;
                    vm.lot.purchase.strengthDisplay = data.data.strengthDisplay;
                    vm.lot.purchase.qualityDescriptionDisplay = data.data.qualityDescriptionDisplay;
                    vm.lot.purchase.qualityGreenCardDsiplay = data.data.qualityGreenCardDsiplay;
                    vm.lot.purchase.lengthDisplay = data.data.lengthDisplay;
                    vm.lot.purchase.unfDisplay = data.data.unfDisplay;
                    vm.lot.purchase.strengthDisplay = data.data.strengthDisplay;
                    vm.lot.purchase.rangeDisplay = data.data.rangeDisplay;
                    vm.showPContractDetails = true;
                }, function(error) {
                    ToastrService.error("Failed to get Purchase Contract quality", "Error");
                    vm.showPContractDetails = false;
                });
            }
        }

        function clearShipment() {
            vm.lot.purchSi = null;
            vm.lot.allocSale = null;
            vm.lot.allocSi = null;
            vm.lot.lotStatus = "AVAILABLE";
        }

        //get purchase contracts
        function fetchPurchaseContractList() {
            vm.pContractList = [];
            ContractCustomService.returnMinifiedContractsByType('PURCHASE').then(function(data) {
                vm.pContractList = data.data;
            }, function(error) {
                ToastrService.error("Failed to fetch Purchase Contracts", "Error");
            });
            // vm.pContractList = Contract.query({type:'PURCHASE'});
        }

        //fetch shipments
        function fetchShipments() {
            vm.siList = [];
            var pConId = null;
            var sConId = 0;
            if( vm.lot.purchase !== null && vm.lot.purchase !== undefined ) {
                pConId = vm.lot.purchase.id;
                ShipmentCustomService.returnMinifiedShipmentsByPurchaseAndSaleContract(pConId, sConId).then(function(data) {
                    vm.siList = data.data;
                    if(vm.lot.purchSi !== null && vm.lot.purchSi !== undefined) {
                        var exists = vm.siList.some(function(val) {
                            return val.id === vm.lot.purchSi.id;
                        });
                        if(!exists) {
                            vm.siList.push(vm.lot.purchSi);
                        }
                    }
                }, function(error) {
                    ToastrService.error("Failed to fetch Shipment list", "Error");
                });
                // if( vm.lot.id !== null ) {
                //     ShipmentCustomService.returnShipmentByLot(vm.lot.id).then(function(data) {
                //         vm.siList.push(data.data);
                //     }, function(error) {
                //         ToastrService.error("Could not get Lot's Shipment", "Error!");
                //     });
                // }
                // ShipmentCustomService.returnShipmentsByPurchContractAndSaleContract( pConId, sConId ).then( function( data ) {
                //     angular.forEach(data.data, function(value, key) {
                //         if(vm.siList.indexOf(value) < 0) {
                //             vm.siList.push(value);
                //         }
                //     });
                //     if( vm.siList.length > 0 ) {
                //         ToastrService.success( "Fetched Shipment list success", "Success!");
                //     }
                // }, function( error ) {
                //     if( error.status !== 404 ) {
                //         ToastrService.error("Cannot fetch Shipment list: " + error.statusText, "Error");
                //     } else {
                //         ToastrService.warning( "No Available Shipment with chosen Purchase Contract");
                //     }
                //     console.log( error.statusText );
                // });
            }
        }

        //=========================================
        //LOT DETAILS TAB
        //=========================================
        //set date picker open statuses
        vm.datePickerOpenStatus.loadingDate = false;


        //open selected calendar
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        //setting lot status with selected lot status button
        function activateLotStatus( option ) {
            vm.lot.lotStatus = option;
        }

        //setting lot purchase wt type with selected unit type button
        function activateWtType( option ) {
            vm.lot.purchWtType = option;
            assignWeights();
        }

        //calculate avg weight based on qty bales and net & landed net weight
        function calculateAvgNet() {
            if( isNaN( vm.lot.qtyBales ) || vm.lot.qtyBales === null || vm.lot.qtyBales === '' || vm.lot.qtyBales === undefined ) {
                vm.lot.qtyBales = 1;
            }
            //set actual avgs
            var actualTare = vm.actualWeightGross - vm.actualWeightNet;
            vm.actualWeightAvg = Math.round(( vm.actualWeightNet / vm.lot.qtyBales ) * 100 ) / 100;
            vm.actualWeightGrossAvg = Math.round( ( vm.actualWeightGross / vm.lot.qtyBales ) * 100 ) / 100;
            vm.actualWeightTareAvg = Math.round( ( actualTare / vm.lot.qtyBales ) * 100 ) / 100;
            vm.lot.actualWtAvg = vm.actualWeightAvg;
            vm.lot.actualWtGrossAvg = vm.actualWeightGrossAvg;
            vm.lot.actualWtTareAvg = vm.actualWeightTareAvg;
            //set landed avgs
            var landedTare = vm.landedWeightGross - vm.landedWeightNet;
            vm.landedWeightAvg = Math.round(( vm.landedWeightNet / vm.lot.qtyBales ) * 100 ) / 100;
            vm.landedWeightGrossAvg = Math.round( ( vm.landedWeightGross / vm.lot.qtyBales ) * 100 ) / 100;
            vm.landedWeightTareAvg = Math.round( ( landedTare / vm.lot.qtyBales ) * 100 ) / 100;
            vm.lot.landedWtAvg = vm.landedWeightAvg;
            vm.lot.landedWtGrossAvg = vm.landedWeightGrossAvg;
            vm.lot.landedWtTareAvg = vm.landedWeightTareAvg;
            if( vm.lot.purchWtType !== "" || vm.lot.purchWtType !== null || vm.lot.purchWtType !== undefined ) { //if a unit type is selected
                assignWeights();
            }
        }

        //assign weights to chosen wt type
        function assignWeights() {
            var actualNet = vm.actualWeightNet;
            var actualGross = vm.actualWeightGross;
            var actualTare = Math.round( ( actualGross - actualNet ) * 100 ) / 100;
            vm.actualWeightTare = actualTare;
            var landedNet = vm.landedWeightNet;
            var landedGross = vm.landedWeightGross;
            var landedTare = Math.round( ( landedGross - landedNet ) * 100 ) / 100;
            vm.landedWeightTare = landedTare;
            switch( vm.lot.purchWtType ) {
            case 'KG':
                //actual
                vm.lot.purchNetKgs = actualNet;
                vm.lot.purchGrossKgs = actualGross;
                vm.lot.purchTareKgs = actualTare;
                //landed
                vm.lot.purchLandedNetKgs = landedNet;
                vm.lot.purchLandedGrossKgs = landedGross;
                vm.lot.purchLandedTareKgs = landedTare;
                //lot weight kgs
                vm.lot.lotWeightKgs = landedNet;
                resetWeights( "LB" );
                resetWeights( "MT" );
                break;
            case 'LB':
                //actual
                vm.lot.purchNetLbs = actualNet;
                vm.lot.purchGrossLbs = actualGross;
                vm.lot.purchTareLbs = actualTare;
                //landed
                vm.lot.purchLandedNetLbs = landedNet;
                vm.lot.purchLandedGrossLbs = landedGross;
                vm.lot.purchLandedTareLbs = landedTare;
                //lot weight lbs
                vm.lot.lotWeightLbs = landedNet;
                resetWeights( "KG" );
                resetWeights( "MT" );
                break;
            case 'MT':
                //actual
                vm.lot.purchNetMTs = actualNet;
                vm.lot.purchGrossMTs = actualGross;
                vm.lot.purchTareMTs = actualTare;
                //landed
                vm.lot.purchLandedNetMTs = landedNet;
                vm.lot.purchLandedGrossMTs = landedGross;
                vm.lot.purchLandedTareMTs = landedTare;
                //lot weight mts
                vm.lot.lotWeightMts = landedNet;
                resetWeights( "LB" );
                resetWeights( "KG" );
                break;
            }
            vm.lot.lotWeightDisplay = landedNet + " " + vm.lot.purchWtType;
        }

        //reset weights to wt types not chosen. Will be calculated on backend.
        function resetWeights( wtType ) {
            switch( wtType ) {
                case 'KG':
                    //actual
                    vm.lot.purchNetKgs = 0;
                    vm.lot.purchGrossKgs = 0;
                    vm.lot.purchTareKgs = 0;
                    //landed
                    vm.lot.purchLandedNetKgs = 0;
                    vm.lot.purchLandedGrossKgs = 0;
                    vm.lot.purchLandedTareKgs = 0;
                    //lot weight
                    vm.lot.lotWeightKgs = 0;
                    break;
                case 'LB':
                    //actual
                    vm.lot.purchNetLbs = 0;
                    vm.lot.purchGrossLbs = 0;
                    vm.lot.purchTareLbs = 0;
                    //landed
                    vm.lot.purchLandedNetLbs = 0;
                    vm.lot.purchLandedGrossLbs = 0;
                    vm.lot.purchLandedTareLbs = 0;
                    //lot weight
                    vm.lot.lotWeightLbs = 0;
                    break;
                case 'MT':
                    //actual
                    vm.lot.purchNetMTs = 0;
                    vm.lot.purchGrossMTs = 0;
                    vm.lot.purchTareMTs = 0;
                    //landed
                    vm.lot.purchLandedNetMTs = 0;
                    vm.lot.purchLandedGrossMTs = 0;
                    vm.lot.purchLandedTareMTs = 0;
                    //lot weight
                    vm.lot.lotWeightMts = 0;
                    break;
            }
        }

        //=========================================
        //LOT QUALITY TAB
        //=========================================
        vm.applyLotQuality = function( type ) {
            if( vm.lot.purchase != null ) {
                switch( type ) {
                    case 'display':
                        vm.lot.lotMic = vm.lot.purchase.micDisplay;
                        vm.lot.lotLen = vm.lot.purchase.stapleDisplay;
                        vm.lot.lotStr = vm.lot.purchase.strengthDisplay;
                        break;
                    default:
                        vm.lot.lotMic = vm.lot.purchase.mic;
                        vm.lot.lotLen = vm.lot.purchase.staple;
                        vm.lot.lotStr = vm.lot.purchase.strength;
                        break;
                }
                ToastrService.info( "Applied P.Contract's " + type + " quality to Lot.", "Info" );
            } else {
                ToastrService.info( "No Purchase Contract Selected", "Info" );
            }
        };

        //=========================================
        //COMMENTS TAB
        //=========================================
        vm.addComment = addComment;
        vm.editComment = editComment;
        vm.editUnsavedComment = editUnsavedComment;
        vm.showCommentAudit = showCommentAudit;
        vm.verifyCommentDelete = verifyCommentDelete;
        vm.verifyCommentUnsavedDelete = verifyCommentUnsavedDelete;

        //action behind the add comment button
        function addComment() {
            if( vm.comment.length > 0 ) { //if there is actual comment
                //create comment object then push to lot.comments
                if( vm.lot.id != null ) { //save comment
                    var comment = [];
                    comment.push( createComment( vm.comment ) );
                    CommentCustomService.assignParentToComment( comment, vm.lot.id, "lot" ).then( function() {
                        resolveComments();
                        ToastrService.success( "Added Comment to Lot", "Success!" );
                    }, function() {
                        ToastrService.error("Failed to save comment", "Error");
                    });
                } else { //push to array to be saved along with the lot
                    vm.comments.push( createComment( vm.comment ) );
                    ToastrService.info( "Added Comment to Lot", "Info" );
                }
                //clear comment text area
                vm.comment = "";
            }
        };

        //create comment object
        function createComment( comment ) {
            var com = {
                "id": null,
                "createdOn": new Date(),
                "createdBy": vm.principal.login,
                "modifiedOn": new Date(),
                "modifiedBy": vm.principal.login,
                "comment": comment,
                "active": true
            };
            return com;
        }

        //edit existing comment
        function editComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return Lot.get({id: vm.lot.id }).$promise;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        };

        //edit comment saved in memory
        function editUnsavedComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-dialog.html',
                controller: 'CommentUnsavedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        };

        //show comment audit trail
        function showCommentAudit( id ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-audit-dialog.html',
                controller: 'CommentAuditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return Comment.get({ id: id }).$promise;
                    }
                }
            }).result.then( function() {
                // resolveComments();
            });
        };

        //delete existing comment
        function verifyCommentDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return Lot.get({ id: vm.lot.id }).$promise;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal == true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        };

        //delete comment saved in memory
        function verifyCommentUnsavedDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-delete-dialog.html',
                controller: 'CommentUnsavedDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal == true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        };

        //=========================================
        //ATTACHMENTS TAB
        //=========================================
        //attachment actions
        vm.deleteTempAttachment = deleteTempAttachment;
        vm.downloadAttachment = downloadAttachment;
        vm.deleteAttachment = deleteAttachment;
        //File Uploading
        $scope.files = [];
        $scope.uploadFile = function (file) {
            if( file && file.length ) {
                angular.forEach( file, function( file ) {
                    $scope.files.push( file );
                    if( vm.lot.id !== null ) {
                        AttachmentCustomService.uploadAttachment( file, "lot", vm.lot.id, file.name ).then( function( data ) {
                            vm.attachments.push( data.data );
                            ToastrService.success( "Successfully uploaded attachment", "Success!" );
                        }, function( error ) {
                            if( error.status !== 404 ) {
                                ToastrService.error( "Something went wrong with the attachment: " + error.statusText, "Error" );
                            }
                            console.log( error.statusText );
                        });
                        var index = $scope.files.indexOf( file );
                        $scope.files.splice( index, 1 );
                    }
                });
            }
        };

        function deleteTempAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-remove-modal.html',
                controller: 'AttachmentRemoveModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return $scope.files[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal == true) {
                    $scope.files.splice( index, 1 );
                    ToastrService.success("Successfully removed Attachment", "Success!");
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        function deleteAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.attachments[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    vm.attachments.splice( index, 1 );
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }
        //=========================================
        //RESOLVE STUFF
        //=========================================
        function resolveAttachments() {
            AttachmentCustomService.returnAttachmentsByLot( vm.lot.id ).then( function( data ) {
                vm.attachments.length = 0;
                vm.attachments = data.data;
                // if( vm.attachments.length > 0 ) {
                //     ToastrService.success( "Grabbed Attachments Success", "Success!" );
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Failed to get attachments: " + error.statusText, "Error!" );
                }
                console.log( error.statusText );
            });
        }

        function resolveComments() {
            vm.comments.length = 0;
            CommentCustomService.returnCommentsByLot( vm.lot.id ).then( function( data ) {
                vm.comments.length = 0;
                vm.comments = data.data;
                // if( vm.comments.length > 0 ) {
                //     ToastrService.success( "Grabbed Comments Success", "Success!" );
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Failed to get Comments: " + error.statusText, "Error!" );
                }
                console.log( error.statusText );
            });
        }
    }
})();
